import { render } from "./index.vue?vue&type=template&id=5a5ed0f2"
import script from "./toast.ts?vue&type=script&lang=js"
export * from "./toast.ts?vue&type=script&lang=js"

import "./toast.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script